import { createRouter, createWebHashHistory } from 'vue-router';

import routes from './setRoutes';

const routerHistory = createWebHashHistory();
 
const router = createRouter({
    history: routerHistory,
    routes
});

// before Router handle page title
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.matched[0].meta.title + ' - ' + to.meta.title;
  }
  next();
})

export default router